export const APP_NAME = 'servicio-chatbot';
